import { defineMessages, useIntl } from 'react-intl';
import { useState } from 'react';
import { Edit } from '@carbon/icons-react';

import CommonButton from 'Components/Common/CommonButton/CommonButton';
import { useUpdatePointMutation } from 'api/pointsEndpoints';
import PointsHandler from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/PointsHandler/PointsHandler';
import sharedMessages from 'Components/utils/sharedMessages';
import { PointDto } from 'api/dtos/point';
import useGetCurrentEntityId from 'hooks/useGetCurrentEntityId';

type ModalProps = {
    point: PointDto;
    open: boolean;
    onClose: () => void;
    onSuccess?: () => void;
}

const PointOperationEditModal = ({
    point, open, onClose, onSuccess,
}: ModalProps) => {
    const intl = useIntl();
    const initialOperationType = point.value > 0 ? 'added' : 'removed';
    const currentEntityId = useGetCurrentEntityId();

    const [updatePoint, { isLoading }] = useUpdatePointMutation();

    const handleFormSubmit = async (reason: string, numberOfPointsToChange: number) => {
        if (!currentEntityId) {
            return;
        }

        await updatePoint({
            entityId: currentEntityId,
            data: {
                id: point.id,
                description: reason,
                value: numberOfPointsToChange,
            },
        }).unwrap();
        onSuccess?.();
    };

    return (
        <PointsHandler
            label={intl.formatMessage(messages.editLabel)}
            onClose={onClose}
            open={open}
            initialOperationType={initialOperationType}
            initialReason={point.description}
            initialPoints={Math.abs(point.value)}
            onSubmit={handleFormSubmit}
            isLoading={isLoading}
        />
    );
};

type Props = {
    point: PointDto;
    onSuccess?: () => void;
}

const PointsOperationEdit = ({
    point,
    onSuccess,
}: Props) => {
    const intl = useIntl();

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <CommonButton
                align="left"
                label={intl.formatMessage(sharedMessages.edit)}
                kind="ghost"
                iconSize={21}
                icon={<Edit />}
                onClick={onOpen}
            />
            <PointOperationEditModal
                point={point}
                onClose={onClose}
                open={open}
                onSuccess={onSuccess}
            />
        </>

    );
};

const messages = defineMessages({
    editLabel: {
        id: 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.Details.Components.PointsHistoryTable.PointsOperationEdit.PointsOperationEdit.editLabel',
        defaultMessage: 'Zaktualizuj operacje na punktach',
    },
});

export default PointsOperationEdit;
